import React from 'react';
import Icon from './Icon';

const LogoutIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 3V11M17.66 6.34A8 8 0 1 1 6.34 6.34"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default LogoutIcon;